import React, { SetStateAction, createContext, useContext, useState } from "react";
import type { Dispatch } from "react";
import * as T from "../types";

export type AppContextProps = {
  accessToken: string;
  darkMode: boolean;
  config: T.AppConfig;
  setConfig: Dispatch<SetStateAction<T.AppConfig>>;
};

const AppContext = createContext<AppContextProps>({
  accessToken: "",
  darkMode: false,
  config: null,
  setConfig: () => null
});

const AppProvider: React.FC = ({ children, accessToken, initialDarkMode = false }: T.AppProviderProps) => {
  const [darkMode, setDarkMode] = useState(initialDarkMode);
  const [config, setConfig] = useState<T.AppConfig | null>(null);
  return (
    <AppContext.Provider value={{ accessToken, darkMode, setDarkMode, config, setConfig }}>
      {children}
    </AppContext.Provider>
  );
};

const useApp = (): AppContextProps => {
  const context = useContext<AppContextProps>(AppContext);
  if (!context) {
    throw new Error("useAuth must be used within a AuthProvider");
  }
  return context;
};

export { useApp, AppProvider, AppContext };
